// extracted by mini-css-extract-plugin
module.exports = {"dmsInput":"padCreatePage_dmsInput__30FB0"};